import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { KindOfOrder } from '../../../../types/enums';
import { Message } from '../types/Message';

export const useGetMessages = (orderID: number, kindOfOrder: KindOfOrder, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['messages', orderID, kindOfOrder],
        queryFn: async () => await apiClient.get('communication/messages',
            { params: { orderID: orderID, kindOfOrder: kindOfOrder } }) as Message[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
